/**
 * Feature flags.
 *
 * AUTH_ENABLED: set to true once backend auth is wired up.
 * When false, Landing redirects straight to the game menu and
 * all auth routes (/login, /signup, /email-confirmation) redirect as well.
 *
 * MULTIPLAYER_ENABLED: set to true to re-enable multiplayer for testers.
 * When false, Create Match / Join Match are hidden on the home screen and
 * /create (for non-quick modes), /join, and /lobby all redirect to /menu.
 *
 * RESTRICT_TO_FOUR_PLAYERS: testing-phase simplification — set to false to
 * restore the 3/4/5/6 player-count picker. When true, the setup wizard's
 * player-count step becomes a single 4-player confirmation screen instead
 * of a grid of options.
 *
 * MANUAL_SEATING_ENABLED: testing-phase simplification — set to true to
 * restore the seating-arrangement step. When false, the setup wizard skips
 * it entirely and seating is always 'automatic'.
 */
export const FEATURES = {
  AUTH_ENABLED: false,
  MULTIPLAYER_ENABLED: false,
  RESTRICT_TO_FOUR_PLAYERS: true,
  MANUAL_SEATING_ENABLED: false,
} as const
